import { TPromoType } from '../../../../types/newBuldings/promo';

import bankIcon from './icons/bank.svg';
import bonusIcon from './icons/bonus.svg';
import discountIcon from './icons/discount.svg';
import mortgageIcon from './icons/mortgage.svg';

export const PROMO_ICONS_MAP = new Map<TPromoType, string>([
  ['bank', bankIcon],
  ['bonus', bonusIcon],
  ['discount', discountIcon],
  ['mortgage', mortgageIcon],
]);
